import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING } from "const"
import { MtTagCreate } from "server/models"
import { StateType } from "client/utils"
import {
    StoreType,
    TagValidation,
    SaveTag,
    setTagEdit,
    setTagReloadList,
} from "client/store"
import {
    Button,
    ConfirmWrapper,
    Confirm,
    ConfirmTitle,
    ConfirmBottom,
    FormGroup,
    Input,
    Feedback,
    SpinnerIcon,
} from "client/components"

const Edit = () => {
    const tag = useSelector((state: StoreType) => state.tag.tagEdit)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [name, setName] = useState(tag ? tag.name : "")
    const [validation, setValidation] = useState<TagValidation>(null)

    const [saveState, setSaveState] = useState<StateType>(IDLE)

    useEffect(() => {
        setName(tag ? tag.name : "")
        setValidation(null)
    }, [tag])

    const onCancel = () => {
        dispatch(setTagEdit(null))
    }

    const onSave = () => {
        setSaveState(PENDING)

        const newTagData: MtTagCreate = {
            name,
        }

        SaveTag(tag && tag.id, newTagData, lang)
        .then((res) => {
            setValidation(res.validation)
            setSaveState(IDLE)
            if (res.validation) return

            dispatch(setTagReloadList(false))
            setTimeout(() => {
                dispatch(setTagReloadList(true))
            }, 0)

            dispatch(setTagEdit(null))
        })
    }

    return (
        <ConfirmWrapper show={tag !== null} onClose={onCancel}>
            <Confirm>
                <ConfirmTitle>{tag && tag.id ? lang.editTag : lang.addTag}</ConfirmTitle>
                <FormGroup>
                    <Input type="text" value={name} onChange={(e) => setName(e.target.value)} />
                    <Feedback>{validation && validation.name}</Feedback>
                </FormGroup>

                <ConfirmBottom>
                    <Button variant="success" row onClick={onSave}>
                        {saveState === PENDING ? <SpinnerIcon /> : lang.save}
                    </Button>
                    <Button row onClick={onCancel}>
                        {lang.cancel}
                    </Button>
                </ConfirmBottom>
            </Confirm>
        </ConfirmWrapper>
    )
}
export default Edit
